<template>
  <div>
    <div class="table-container-v3 margin-25">
      <table class="table table-v3 is-fullwidth is-striped webhook-table">
        <thead>
          <tr>
              <th class="has-text-centered px-4 column-url">URL</th>
              <th class="has-text-centered px-4 column-description">Descripción</th>
              <th class="has-text-centered px-4 column-status">Estatus</th>
              <th class="has-text-centered px-4 column-actions">Acciones</th>
          </tr>
        </thead>
        <tbody v-if="!isLoading && webhooks.length">
          <tr v-for="(item, index) in webhooks" :key="index">
            <td class="has-text-centered">{{ item.url }}</td>
            <td class="has-text-centered">{{ item.description }}</td>
            <td class="has-text-centered">
              <span class="is-status" :class="item.enabled ? 'is-status-active' : 'is-status-inactive'">
                {{ item.enabled ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td class="has-text-centered">
              <div class="dropdown">
                <a id="panelNavBurger" role="button" data-target="panelNavMenu" aria-expanded="false" aria-label="menu"
                  class="dropbtn">
                  <i class="fas fa-ellipsis-v" />
                </a>
                <div class="dropdown-content">
                  <a class="navbar-item" v-if="['admin', 'developer', 'manager'].includes(role.code)" @click="toggleModalEdit(item)">
                    <i class="show-on-hover fas fa-chevron-right" />
                    Ver detalle
                  </a>
                  <a class="navbar-item" @click="toggleStatus(item)"
                    v-if="['admin', 'developer', 'manager'].includes(role.code)">
                    <i class="show-on-hover fas fa-chevron-right" />
                    {{ item.enabled ? 'Desactivar' : 'Activar' }}
                  </a>
                  <a class="navbar-item" :disabled="(!item.enabled) ? true : false"
                    v-if="['admin', 'developer', 'manager'].includes(role.code)" @click="(item.enabled) ? probarWebhook(item) : ''">
                    <i class="show-on-hover fas fa-chevron-right" />
                    Ejecutar
                  </a>
                  <a class="navbar-item" :disabled="(!item.enabled) ? true : false"
                    v-if="['admin', 'developer', 'manager'].includes(role.code)" @click="(item.enabled) ? eliminarWebhook(item) : ''">
                    <i class="fas fa-chevron-right show-on-hover" />
                    Eliminar
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="isLoading">
          <tr>
            <td colspan="7" class="has-text-centered">
              <div class="lds-dual-ring"></div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="has-text-centered -text3 -gray">
              Sin información
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="column is-12 has-text-centered">
      <paginator :page="pagination.pageNumber" :pages="pagination.totalPages" :loading="false" :action="getWebhooks" />
    </div>
    <ModalEditWebhook
      v-if="isShowModalEdit"
      :showModal="isShowModalEdit"
      :close="closeModal"
      :webhook="webhook"
    />
    <ModalDeleteWebhook
      v-if="isShowModalDelete"
      :showModal="isShowModalDelete"
      :close="closeModalDelete"
      :webhook="webhook"
      :getWebhooks="getWebhooks"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
import ModalEditWebhook from './ModalEditWebhook.vue'
import ModalDeleteWebhook from './ModalDeleteWebhook.vue'
export default {
  name: 'Webhooks',
  components: {
    Paginator: () => import('@/components/ui/BasePagination.vue'),
    ModalEditWebhook,
    ModalDeleteWebhook
  },
  mixins: [mixins],
  props: {
    webhooks: {
      type: Array
    },
    pagination: {
      type: Object
    },
    role: {
      type: Object
    },
    getWebhooks: {
      type: Function
    },
    isLoading: {
      type: Boolean
    },
    probarWebhook: {
      type: Function
    }
  },
  data () {
    return {
      loadingv2: false,
      isShowModalEdit: false,
      isShowModalDelete: false,
      headers: '',
      url: '',
      description: '',
      eventId: Number,
      error: '',
      webhook: {}
    }
  },
  methods: {
    ...mapActions(['updateWebhookStatus']),
    async toggleModalEdit (webhook) {
      this.webhook = webhook
      this.isShowModalEdit = !this.isShowModalEdit
    },
    async updateWebhook () {},
    async toggleStatus (webhook) {
      this.loadingv2 = true
      await this.updateWebhookStatus({ webhookId: webhook.id }).then(resp => {
        this.loadingv2 = false
        if (resp.success) {
          webhook.enabled = !webhook.enabled
        }
      }).catch(error => {
        this.loadingv2 = false
        this.error = error.message || 'Error updating webhook status'
      })
    },
    closeModal () {
      this.isShowModalEdit = false
    },
    closeModalDelete () {
      this.isShowModalDelete = false
    },
    eliminarWebhook (webhook) {
      this.isShowModalDelete = true
      this.webhook = webhook
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    })
  }
}
</script>

<style lang="scss" scoped>
.webhook-table td {
  padding: 0.7rem 1rem;
}
.disabled {
  cursor: not-allowed;
  color: gray !important;
}
.column-description {
  width: 25%;
  min-width: 150px;
}
.column-url {
  width: 30%;
}
.column-status {
  width: 10%;
}
.column-actions {
  width: 10%;
}
</style>
